<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<p class="TITLE" id="_idParaDest-1">The God We Worship</p>
<p class="SUBTITLE">An Exploration of Liturgical Theology</p>
<p class="AUTHOR">Nicholas Wolterstorff</p>
<p class="COMPANY">William B. Eerdmans Publishing Company<br/>Grand Rapids, Michigan / Cambridge, U.K.</p>
<p class="COPYRIGHT">© 2015 Nicholas Wolterstorff<br/>All rights reserved<br/><br/>Published 2015 by<br/>Wm. B. Eerdmans Publishing Co.<br/>2140 Oak Industrial Drive N.E., Grand Rapids, Michigan 49505 /<br/>P.O. Box 163, Cambridge CB3 9PU U.K.<br/><br/>Printed in the United States of America</p>
<p class="LIBRARY">Library of Congress Cataloging-in-Publication Data</p>
<p class="CIP">ISBN 978-0-8028-7249-4</p>
<p class="CIP">eISBN 978-1-4674-4329-6 (ePub)</p>
<p class="CIP">eISBN 978-1-4674-4289-3 (Kindle)</p>
<p class="URL"><a href="http://www.eerdmans.com" target="_blank">www.eerdmans.com</a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Wolterstorff_The_God_We_Worship_text_CC-2.vue?8af99a3c